import { log } from "../utils/common";

export const reportError = async (title, error) => {
    log(title, "", "red", error);
};
